import { Injectable } from '@angular/core';

@Injectable()
export class UserCardService {

    Print(userIds: number[]) {
        window.open('/UserCards?q=' + userIds.join(','), '_blank');
    }
}
